export const STATUS_LABELS = {
    critico: "Crítico",
    atencao: "Atenção",
    saudavel: "Saudável",
    excelente: "Excelente",
};

export const STATUS_ORDER = ["critico", "atencao", "saudavel", "excelente"];

export const FASE_LABELS = {
    onboarding: "Onboarding",
    personalizacao: "Personalização",
    adocao: "Adoção",
    expansao: "Expansão",
    renovacao: "Renovação",
};

export const PLANO_LABELS = {
    premium: "Premium",
    personalizado: "Personalizado",
    especial: "Especial",
};

export const CLIMA_LABELS = {
    ruim: "Ruim",
    razoavel: "Razoável",
    bom: "Bom",
    otimo: "Ótimo",
};

export const RESPONSAVEL_LABELS = ["Comercial", "Suporte", "Jurídico Cliente", "Jurídico Produto", "Desenvolvimento"];

// M18 — módulos de treinamento (lista nova, seleção múltipla)
export const TREINO_MODULOS = [
    "Geral",
    "Mensagens/Consultas",
    "Documentos Gerados",
    "Analisador",
    "Pesquisa de Preços",
    "Radar de Fornecedor",
    "Ata Inteligente",
];

// M3 — baixa de contato pelo Dashboard
export const CONTATO_FORMAS = [
    { value: "ligacao", label: "Ligação" },
    { value: "email", label: "E-mail" },
    { value: "whatsapp", label: "WhatsApp" },
    { value: "video", label: "Chamada de vídeo" },
    { value: "presencial", label: "Visita presencial" },
    { value: "outro", label: "Outro" },
];

export const CONTATO_RESPONSAVEIS = [
    "Comercial", "Suporte", "Jurídico Cliente", "Jurídico Produto", "Desenvolvimento",
];

export function statusColor(status) {
    return {
        critico: "#EF4444",
        atencao: "#F59E0B",
        saudavel: "#22C55E",
        excelente: "#10B981",
    }[status] || "#94A3B8";
}

export function statusBadgeClass(status) {
    return `badge-status badge-${status || "neutral"}`;
}

export function brl(date) {
    if (!date) return "—";
    const d = typeof date === "string" ? new Date(date + "T00:00:00") : date;
    return d.toLocaleDateString("pt-BR");
}

export function brlDateTime(date) {
    if (!date) return "—";
    const d = typeof date === "string" ? new Date(date) : date;
    return d.toLocaleString("pt-BR");
}

export function monthLabel(mesRef) {
    if (!mesRef) return "";
    const [y, m] = mesRef.split("-");
    const meses = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
    return `${meses[parseInt(m, 10) - 1]}/${y}`;
}

export function fmtPct(v, opts = { signed: false, decimals: 1 }) {
    if (v === null || v === undefined || Number.isNaN(v)) return "—";
    const sign = opts.signed && v > 0 ? "+" : "";
    return `${sign}${Number(v).toFixed(opts.decimals ?? 1)}%`;
}

export function toCurrentMonthRef() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

// M8 — último mês encerrado (ex.: em julho retorna junho)
export function toLastClosedMonthRef() {
    const d = new Date();
    const lastClosed = new Date(d.getFullYear(), d.getMonth(), 0);
    return `${lastClosed.getFullYear()}-${String(lastClosed.getMonth() + 1).padStart(2, "0")}`;
}
